import { useTranslation } from 'react-i18next';
import GamesNew from './GamesNew';
import ContactNew from './ContactNew';
import AboutNew from './AboutNew';
import FilmsNew from './FilmsNew';
import MainNew from './MainNew';
import NavBarNew from './NavBarNew';
import SocialBar from './SocialBar';
import Mailer from './Mailer';
import React, { useState, useEffect, useRef } from "react";

function HeaderNew() {
  const { t } = useTranslation();
  const [activeComponent, setActiveComponent] = useState("Home");
  const [fade, setFade] = useState(false);
  const [nextComponent, setNextComponent] = useState("Home");
  const [homeReset, setHomeReset] = useState(0); // 👈 NUEVO

  const overlayRef = useRef(null);

  // Fade inicial
  useEffect(() => {
    const timer = setTimeout(() => setFade(true), 50);
    return () => clearTimeout(timer);
  }, []);

  // Cambio de sección con fade
  useEffect(() => {
    if (nextComponent !== activeComponent) {
      setFade(false);

      const timer = setTimeout(() => {
        setActiveComponent(nextComponent);
        setFade(true);

        // scroll arriba
        if (overlayRef.current) {
          overlayRef.current.scrollTo({
          top: 0,
          behavior: "smooth",
    });
        }

      }, 500);

      return () => clearTimeout(timer);
    }
  }, [nextComponent, activeComponent]);

  // 👇 render con key dinámica en Home
  const renderComponent = () => {
    switch (activeComponent) {
      case "Home":
        return <MainNew key={homeReset} />;
      case "Films":
        return <FilmsNew />;
      case "About":
        return <AboutNew />;
      case "Contact":
        return <ContactNew />;
      default:
        return <MainNew key={homeReset} />;
    }
  };

  // 👇 handleSelect modificado
  const handleSelect = (comp) => {
    // si ya estás en Home → forzar reset
    if (comp === "Home" && activeComponent === "Home") {
      setHomeReset(prev => prev + 1);

      // scroll arriba inmediato
if (overlayRef.current) {
  overlayRef.current.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}
    }

    setNextComponent(comp);
  };

  return (
    <header className="masthead text-white text-center">
      
      <NavBarNew onSelect={handleSelect} />

      <div className="overlay-backdrop" ref={overlayRef}>
        <div className={`content-container fade-component ${fade ? "show" : ""}`}>
          {renderComponent()}
        </div>
      </div>

      <SocialBar />
    </header>
  );
}

export default HeaderNew;